import React, { forwardRef, useRef } from 'react';
import './Input.css';

const Input = forwardRef((props, ref) => {
  const {
    label,
    type = 'text',
    value,
    onChange,
    placeholder,
    disabled = false,
    error,
    required = false,
    className = '',
    size = 'md',
    icon,
    autoFocus = false,
    autoComplete = 'on',
    inputMode
  } = props;
  
  const inputId = React.useId();
  
  const baseClass = 'input';
  const sizeClass = `input-${size}`;
  const errorClass = error ? 'input-error' : '';
  const disabledClass = disabled ? 'input-disabled' : '';
  const iconClass = icon ? 'input-with-icon' : '';
  const hasValueClass =
    value !== undefined && value !== null && String(value) !== ''
      ? 'input-has-value'
      : '';
  
  const classes = [
    baseClass,
    sizeClass,
    errorClass,
    disabledClass,
    iconClass,
    hasValueClass,
    className
  ].filter(Boolean).join(' ');

  const internalRef = useRef(null);
  
  // Combine the external ref with our internal ref
  const inputRef = ref || internalRef;

  const handleClear = () => {
    if (onChange) {
      // Input değerini temizlemek için boş string ile onChange'i çağırıyoruz
      const event = { target: { value: '' } };
      onChange(event);
      
      // Input alanına odaklan
      if (inputRef.current) {
        inputRef.current.focus();
      }
    }
  };

  return (
    <div className="input-wrapper">
      {label && (
        <label htmlFor={inputId} className="input-label">
          {label}
          {required && <span className="input-required">*</span>}
        </label>
      )}
      
      <div className="input-container">
        {icon && (
          <div className="input-icon">
            {icon}
          </div>
        )}
        
        <input
          ref={inputRef}
          id={inputId}
          type={type}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          disabled={disabled}
          required={required}
          className={classes}
          autoFocus={autoFocus}
          autoComplete={autoComplete}
          inputMode={inputMode}
        />
        
        {value && type === 'search' && !disabled && (
          <button 
            type="button"
            className="input-clear-button"
            onClick={handleClear}
            aria-label="Temizle"
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        )}
      </div>
      
      {error && (
        <span className="input-error-message">
          {error}
        </span>
      )}
    </div>
  );
});

export default Input;
